import { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import FirebaseFileSaver from '../services/firebase-filesaver';

import WebbLoader from './webb-loader';

import { GetAuthUser, GetUserContactsList } from "../services/user-accounts";
import { CreateUserDocs } from '../services/user-vault';

const stat = [
  {code:"Pending", colr:"warning"},
  {code:"Active", colr:"success"},
  {code:"Expired", colr:"danger"},
  {code:"Inactive", colr:"lite"},
]

const course = require('../data/data-courselist.json').data;

export default function TeamCredsLinkModule() {

  const asset = GetAuthUser();
  const history = useHistory();

  const [list, setList] = useState([]);
  const [text, setText] = useState('');
  const [form, setForm] = useState(false);
  const [loading,setLoading]=useState(false);

  const [data, setData] = useState({
    name: '',
    nmbr: '',
    form: '',
    sort: 'acad',
    docx: 'certificate',
    file: '',
    stat: 0,
    blck: false,
    user: '',
    usid: '',
    stts: (new Date()).toISOString().substr(0,10),
    ents: (new Date()).toISOString().substr(0,10),
    srvc: asset.usid
  })

  useEffect( () => {
    if (asset){
      const fetchData = async() => {
        // contact list
        setList ((await GetUserContactsList(JSON.stringify({ 
          body: {
            sort: '',
            actv: 'active',
            usid: asset.usid,
            form: asset.form
            },
          user: { usid: asset.usid, form: asset.form }
        }))).data)

        setLoading(false);
      }
      fetchData()
    } else {}
  },[asset.usid]);

  // form validation
  useEffect( () => {
    setForm(false)
    if (data.file !=='' && data.nmbr !== '') 
      setForm(true);
  },[data]);

  const handleChange = async(key, val) => {
    setData({ ...data, [key]: val });
  }

  const SetFileLink = async(file) => {
    // console.log (file);
    handleChange("file", file);
  }

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    console.log ({...data, stat: parseInt(data.stat)})
    const response = await CreateUserDocs (JSON.stringify({
      body: { 
        ...data, 
        user: list.find(item=>item.cnid===data.usid).name, 
        stat: parseInt(data.stat),
        // ents: data.stat === 2 ? data.ents : null
      },
      user: { usid: asset.usid, form: asset.form }
    }))
    console.log (response)
    setLoading(false);
    history.push('/bz/team')
  }

  if (loading){
    return ( <> <WebbLoader />  </> )
  }

  return (
    <>
      <p className="lead text-primary fw-bold mb-3">
        {'Academic Credentials'}
      </p>

      <form onSubmit={handleSubmit}>

        <div className="mb-3">
            <div className="form-group">
              <label className="form-label small">Select Contact <span className="text-danger">*</span></label>
              <select className="form-select height-md"
                value={data.usid}
                onChange={({ target }) => {
                  handleChange("usid", target.value);
                }}
              >
                <option value=''>Select Contact</option>
                {list.map((item,i) => (
                  <option key={i} value={item.cnid}>{item.name}</option>
                ))}
              </select>
            </div>
          </div>

        <div className="mb-3">
          <label className="form-label small">Course Name <span className="text-danger">*</span></label>
          <select 
            className="form-select height-md"
            value={data.name}
            onChange={({ target }) => { handleChange("name", target.value) }}>
            <option value=''>Select Course</option>
            {course.map((item,i) => (
              <option key={i} value={item.name}>{item.name}</option>
            ))}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label small">Certificate Number <span className="text-danger">*</span></label>
          <input 
            type="text"     
            className="form-control height-md"   
            value={data.nmbr}
            onChange={({ target }) => {handleChange("nmbr", target.value); setText('');}}
            placeholder="0123456789">
          </input>
        </div>

        <div className="mb-3">
          <label className="form-label small">Certificate Image <span className="text-danger">*</span></label>
          <FirebaseFileSaver name={'sender'} link = {SetFileLink}/>    
        </div>

        <div className="mb-3">
          <div className="form-group">
            <label className="form-label small">Start Date <span className="text-danger">*</span></label>
            <input type="date" className="form-control height-md"
              value={data.stts}
              onChange={({ target }) => {handleChange("stts", target.value); setText('');}}
              placeholder="">
            </input>
          </div>
        </div> 

        <div className="mb-3">
          <div className="form-group">
            <label className="form-label small">End Date <span className="text-danger">*</span></label>
            <input type="date" className="form-control height-md"
              value={data.ents}
              onChange={({ target }) => {handleChange("ents", target.value); setText('');}}
              placeholder="">
            </input>
          </div>
        </div> 

        <div className="mb-3">
          <label className="form-label small">Status <span className="text-danger">*</span></label>
          <select 
            className="form-select height-md"
            value={data.stat}
            onChange={({ target }) => { handleChange("stat", target.value) }}>
            <option value=''>Select Status</option>
            {stat.map((item,i) => (
              <option key={i} value={i}>{item.code}</option>
            ))}
          </select>
        </div>

        <div className="">
          <div className="d-grid">
            <button className={`btn height-md ${ form ? 'btn-primary' : 'btn-light'}`}
              disabled={!form}
            ><small>Save & Continue</small>
            </button>
          </div>
        </div>

      </form>
    </>
  )
}